/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPressReleaseGifAnimationSuccessResponseData,
    PostPressReleaseGifAnimationSuccessResponseDataFromJSON,
    PostPressReleaseGifAnimationSuccessResponseDataFromJSONTyped,
    PostPressReleaseGifAnimationSuccessResponseDataToJSON,
} from './PostPressReleaseGifAnimationSuccessResponseData';

/**
 * POST /press_release/{release_id}/gif_animation
 * @export
 * @interface PostPressReleaseGifAnimationResponse
 */
export interface PostPressReleaseGifAnimationResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseGifAnimationResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleaseGifAnimationResponse
     */
    message: string;
    /**
     * 
     * @type {PostPressReleaseGifAnimationSuccessResponseData}
     * @memberof PostPressReleaseGifAnimationResponse
     */
    data: PostPressReleaseGifAnimationSuccessResponseData;
}

export function PostPressReleaseGifAnimationResponseFromJSON(json: any): PostPressReleaseGifAnimationResponse {
    return PostPressReleaseGifAnimationResponseFromJSONTyped(json, false);
}

export function PostPressReleaseGifAnimationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseGifAnimationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPressReleaseGifAnimationSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostPressReleaseGifAnimationResponseToJSON(value?: PostPressReleaseGifAnimationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPressReleaseGifAnimationSuccessResponseDataToJSON(value.data),
    };
}

